import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import { formatActivityTime } from '../util/dateHelpers';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    cursor: 'pointer',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  icon: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1.75),
    marginBottom: theme.spacing(1.75),
  },
  avatar: {
    width: theme.spacing(11),
    height: theme.spacing(11),
  },
  content: {
    flex: '1 0 auto',
  },
}));

const CardholderCard = ({
  loading,
  isPreview,
  exactTime,
  cardholder: { id, firstName, lastName, title, lastActivity, photo },
}) => {
  const history = useHistory();
  const [activity, setActivity] = useState(formatActivityTime(lastActivity, exactTime));
  const classes = useStyles();
  const theme = useTheme();

  useEffect(() => {
    if (!exactTime) {
      const interval = setInterval(() => {
        setActivity(formatActivityTime(lastActivity, exactTime));
      }, 5000);
      return () => clearInterval(interval);
    }

    return () => {};
  }, [activity, lastActivity, exactTime]);

  const handleEdit = () => {
    history.push({ pathname: `/cardholders/${id}` });
  };

  if (loading) {
    return (
      <Card className={classes.root} square>
        <CardMedia className={classes.icon}>
          <Skeleton variant="circle" width={theme.spacing(11)} height={theme.spacing(11)} />
        </CardMedia>
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <Typography noWrap variant="h6">
              <Skeleton width={theme.spacing(16)} />
            </Typography>
            <Typography noWrap style={{ fontSize: '1.05em' }}>
              <Skeleton width={theme.spacing(24)} />
            </Typography>
            <Typography noWrap style={{ fontSize: '1.05em' }}>
              <Skeleton width={theme.spacing(20)} />
            </Typography>
          </CardContent>
        </div>
      </Card>
    );
  }

  return (
    <Card className={classes.root} square onClick={handleEdit}>
      <CardMedia className={classes.icon}>
        <Avatar alt={`${firstName} ${lastName}`} src={photo} className={classes.avatar} />
      </CardMedia>
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography noWrap variant="h6">
            {firstName} {lastName}
          </Typography>
          <Typography noWrap style={{ fontSize: '1.05em', color: theme.palette.neutral.dark }}>
            {title}
          </Typography>
          <Typography noWrap style={{ fontSize: '1.05em', color: theme.palette.neutral.light }}>
            {lastActivity ? (
              <FormattedMessage
                id="CardholderCard.lastActive"
                description="Cardholder Last Active"
                defaultMessage="Last active {activity}"
                values={{
                  activity,
                }}
              />
            ) : (
              <FormattedMessage
                id="CardholderCard.noActivity"
                description="Cardholder No Activity"
                defaultMessage="No known activity"
              />
            )}
          </Typography>
        </CardContent>
      </div>
    </Card>
  );
};

export default CardholderCard;
